// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mP9Ee","footer":"styles_footer__NAhRm"};